module.exports = __webpack_public_path__ + "img/fuzhou.1298fe97.png";